import { colors, IStyles } from 'theme'

export const defaultThemeStyles: IStyles = {
    main: colors.blackLight,
    mainSub: colors.grey,
    disable: colors.grey,
    active: colors.blackLight,
    light: colors.greyLight,
}
